import { dissoc, isEmpty, propOr } from 'ramda'
import React from 'react'

import { getQueryName } from './graphql'
import { useQuery } from './useQuery'

export const genUpdateQuery =
  (queryName, setDone) =>
  (prev, { fetchMoreResult }) => {
    if (!fetchMoreResult) return prev
    const newList = propOr([], queryName, fetchMoreResult)
    setDone(isEmpty(newList))
    return Object.assign({}, prev, {
      [queryName]: [...propOr([], queryName, prev), ...newList]
    })
  }

export const usePaginatedQuery = (QUERY, props) => {
  const [done, setDone] = React.useState(false)
  const [page, setPage] = React.useState(1)

  const { fetchMore, ...state } = useQuery(QUERY, props)

  // TODO: Think of a better solution. Maybe the page being hadled by apollo
  React.useEffect(() => {
    setPage(1)
    setDone(false)
  }, [JSON.stringify(dissoc('page', state.variables))])

  const queryName = getQueryName(QUERY)

  const handleFetchMore = () => {
    const newPage = (page || 1) + 1
    fetchMore({
      variables: { page: newPage },
      updateQuery: genUpdateQuery(queryName, setDone) //
    })
    setPage(newPage)
  }

  return { ...state, page, fetchMore: handleFetchMore, done }
}
